export class AppraisalProductApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAppraisalProducts() {
    return this.#http.get('/AppraisalProduct');
  }

  async deleteAppraisalProduct({ id }) {
    return this.#http.delete(`/AppraisalProduct/${id}`);
  }

  async getCatalogs() {
    return this.#http.get('/AppraisalProduct/catalogs');
  }

  async createAppraisalProduct(body) {
    return this.#http.post('/AppraisalProduct', body);
  }

  async editAppraisalProduct({ id, ...body }) {
    return this.#http.put(`/AppraisalProduct/${id}`, body);
  }

  // FH-1572: CRUD for the HomeVision Job Type catalog (PR 2b backend routes).
  // Distinct from `getHomeVisionJobTypesList` (`/AppraisalProduct/homevisionjobtypeslist`), the
  // read-only {value,label} dropdown source consumed by ManageAppraisalProductForm via `catalogs`.
  // Active/inactive is a field on the row — toggled through update, not a separate endpoint.
  async getHomeVisionJobTypeSettings() {
    return this.#http.get('/AppraisalProduct/homevisionjobtypes/catalog');
  }

  async createHomeVisionJobTypeSetting(body) {
    return this.#http.post('/AppraisalProduct/homevisionjobtypes', body);
  }

  async updateHomeVisionJobTypeSetting({ id, ...body }) {
    return this.#http.put(`/AppraisalProduct/homevisionjobtypes/${id}`, body);
  }
}
